import { addRumAction } from '../hosting/dataflux-rum';
var getHomePageLoadedDuration = function () {
    var navigationTiming = window.performance.getEntriesByType('navigation')[0];
    var performanceTiming = window.performance.timing;
    return (navigationTiming === null || navigationTiming === void 0 ? void 0 : navigationTiming.duration) || (performanceTiming === null || performanceTiming === void 0 ? void 0 : performanceTiming.loadEventEnd) - (performanceTiming === null || performanceTiming === void 0 ? void 0 : performanceTiming.navigationStart) || 0;
};
export var reportHomePageLoadedDuration = function () {
    var report = function () {
        var duration = getHomePageLoadedDuration();
        window.__HOME_PAGE_LOADED_TS = Date.now();
        addRumAction('home_page_loaded', {
            loadedDuration: duration,
            hashPath: location.hash
        });
    };
    if (getHomePageLoadedDuration() > 0) {
        report();
    }
    else {
        var observer_1 = new PerformanceObserver(function (list) {
            if (getHomePageLoadedDuration() > 0) {
                report();
                observer_1.disconnect();
            }
        });
        observer_1.observe({ entryTypes: ['navigation'] });
    }
};
export var reportHomePagePaintDuration = function () {
    var report = function (e) {
        var _a, _b;
        var customIds = [
            'home-top-view-createNewBill',
            'home-top-view-recordExpends',
            'home-top-view-checkInvoice',
            'home-recent-template-item',
            'home-bill-card-header',
            'home-card-empty',
            'home-template-item',
            'home-banner-view-item',
            'home-mall-list-item',
            'home-bill-list-item',
            'home-my-loan-all'
        ];
        var targetDataTestId = (_a = e.target) === null || _a === void 0 ? void 0 : _a.getAttribute('data-test-id');
        if (customIds.includes(targetDataTestId) || ((_b = e.target) === null || _b === void 0 ? void 0 : _b.closest('.eui-menu-item, .login-card, .ant-menu-item, .template-item'))) {
            document.removeEventListener('click', report, true);
            if (window.__HOME_PAGE_LOADED_TS) {
                addRumAction('home_page_paint', {
                    paintDuration: Date.now() - window.__HOME_PAGE_LOADED_TS,
                    hashPath: location.hash,
                    element: e.target.className
                });
            }
        }
    };
    document.addEventListener('click', report, true);
};
